import React from 'react';
import './radioButton.scss';
import loadingImg from '../../assets/images/loading-green.svg';

const initialState = {
  message: ''
}

class RadioButton extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = { ...initialState }
  }
  componentWillMount() {
    this.formFields = []
  }

  componentDidMount() {
    this._isMounted = true;
    let { returnObject } = this.props;

    if (returnObject) {
      returnObject(this)
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self
  }

  handleChange(event) {
    let { onChange } = this.props;
    let response = { value: event.target.value };
    if (onChange) {
      onChange(response)
    }
    this.validate(event.target.value)
  }

  validate = (value) => {
    return new Promise((re, rj) => {
      let { required, name, check } = this.props
      let isValid = value ? value : check;

      if (required && !isValid)
        rj({ name: name, message: 'Seleção obrigatória.' })
      re(true)

    })
      .then(r => {
        this.setState({ message: '' })
        return r

      })
      .catch(e => {
        this.setState({ message: e.message })
        return false
      })
  }



  render() {

    let { dataSource, check, label, loading } = this.props;
    let { handleChange } = this;

    let value = check || "1";

    return (
      <div className="radio-button">
        {dataSource.length !== 0 && <h4>{label}</h4>}
        {dataSource.length === 0 && loading && <img className="radio-icon" src={loadingImg} alt="loading" />}
        <ul className="radio-container">
          {
            dataSource.map(item =>
              <li className="radio-item" key={item.value}>
                <input className="radio-input" type="radio" id={item.name} checked={value === item.value} value={item.value} onChange={handleChange} />
                <label htmlFor={item.name} title={item.label}>{item.icon ? item.icon : ""}{item.label}</label>
              </li>
            )
          }
        </ul>
        {!!dataSource.length && <span className="message">{this.state.message}</span>}
      </div>
    );
  }
}

export default RadioButton;
